
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.285 20.495a8.5 8.5 0 117.32-4.694l.198.558c.138.386.296.878.348 1.435A9.954 9.954 0 0022 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 5.41 4.297 9.818 9.665 9.994a.75.75 0 00.169.02c1.762 0 3.989-.272 5.477-1.753.696-.692 1.097-1.364 1.178-2.1.078-.719-.168-1.359-.428-1.92l-3.437-7.423L7.23 6.001l-.535 1.402L9.788 8.58l2.169 4.684 3.858 1.695.885 1.912c.243.524.328.842.297 1.126-.028.264-.177.636-.744 1.2-.944.94-2.427 1.26-3.974 1.309l.006-.012zm2.577-7.592l-1.782-.783-1.285-2.774 1.724.657 1.343 2.9z","fill":"currentColor"}})])
          )
        }
      }
    